const filterSpec = (spec: any, group: string) => {
  const allTags: Set<string> = new Set();
  const schemas: string[] = [];
  const filteredPaths: any = {};

  Object.keys(spec.paths).forEach(path => {
    filteredPaths[path] = {};

    Object.keys(spec.paths[path]).forEach(method => {
      const data = spec.paths[path][method];
      if (data.tags && data.tags.includes(`group:${group}`)) {
        const filteredTags = data.tags.filter((tag: string) => tag !== `group:${group}`);
        filteredTags.forEach((tag: string) => allTags.add(tag));

        filteredPaths[path][method] = {
          ...data,
          tags: filteredTags,
        };

        // Response 필터링
        Object.keys(data.responses).forEach(responseCode => {
          const response = data.responses[responseCode];
          const content = response?.content?.['application/json'];
          const ref = content?.schema?.$ref;
          if (ref) {
            const refName = ref.replace('#/components/schemas/', '');
            schemas.push(refName);
          }
        });

        // Schema 필터링
        const requestRef = data.requestBody?.content?.['application/json']?.schema?.$ref;
        if (requestRef) {
          const refName = requestRef.replace('#/components/schemas/', '');
          schemas.push(refName);
        }
      }
    });

    if (Object.keys(filteredPaths[path]).length === 0) {
      delete filteredPaths[path];
    }
  });

  spec.paths = filteredPaths;
  // 태그s ==> 필터링 된 태그로 설정
  spec.tags = spec.tags.filter((tag: any) => tag.name in allTags);

  const filteredSchemas: any = {};
  Object.keys(spec.components.schemas).forEach(schema => {
    if (schemas.includes(schema)) {
      filteredSchemas[schema] = spec.components.schemas[schema];
    }
  });
  spec.components.schemas = filteredSchemas;

  return spec;
};

export default filterSpec;
